import apiFetch from '../apiFetch'

export default function (token, vehicleId) {
  return apiFetch({ endPoint: `vehicle/${vehicleId}`, method: 'GET', body: null, token: token })
}
